module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creams-new"
  }, [_c('creams-form', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "submit": _vm.onSubmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e8fcb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/frontend/components/pages/creams/new.vue
// module id = 119
// module chunks = 1